<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-004"><span epub:type="pagebreak" id="page_XVI" role="doc-pagebreak" title="XVI">
<h1 class="pre_tit" epub:type="title"><span>Abbreviations</span></h1>
<div class="dev">
<div class="tableau" id="tableau-001">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px; width:100%;">
<colgroup style="padding:7px;">
<col style="padding:7px;"/>
<col style="width:76%;"/>
</colgroup>
<tbody>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">AB</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Anchor Bible</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ACCS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Ancient Christian Commentary on Scripture</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ACT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Ancient Christian Texts</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Against Bishops of Oriens</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Cyril of Alexandria, <i>A Defense of the Twelve Anathemas against the Bishops of the Diocese of Oriens</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">AGJU</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Arbeiten zur Geschichte des antiken Judentums und des Urchristentums</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>ANF</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Ante-Nicene Fathers</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BCOTWP</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Baker Commentary on the Old Testament Wisdom and Psalms</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BDAG</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>A Greek-English Lexicon of the New Testament and Other Early Christian Literature</i>. Revised and edited by Frederick William Danker. Chicago: University of Chicago Press, 2000.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BECNT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Baker Exegetical Commentary on the New Testament</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BIS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Biblical Interpretation Series</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BMSEC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Baylor-Mohr Siebeck Studies in Early Christianity</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>BT</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>The Bible Translator</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BTCP</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Biblical Theology for Christian Proclamation</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BZNW</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>C. Ar.</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Athanasius, <i>Orations Against the Arians</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CBET</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Contributions to Biblical Exegesis and Theology</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>CBQ</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Catholic Biblical Quarterly</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>CBR</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Currents in Biblical Research</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ConBOT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Coniectanea Biblica: Old Testament Series</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CTC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Christian Theology in Context</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CTHP</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Cambridge Texts in the History of Philosophy</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Decr.</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Athanasius, <i>Defense of the Nicene Definition</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Diogn.</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">The Epistle to Diognetus</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">EBib</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Etudes bibliques</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ECF</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">The Early Church Fathers</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><span epub:type="pagebreak" id="page_XVII" role="doc-pagebreak" title="XVII">EKKNT</span></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Evangelisch-Katholischer Kommentar zum Neuen Testament</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Ep. Serap.</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Athanasius, <i>Letter to Serapion Concerning the Holy Spirit</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ESV</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">English Standard Version</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">EUS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">European University Studies</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">FC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">The Fathers of the Church</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">FRLANT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">GNO</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Gregorii Nysseni Opera</i>. Edited by Werner Jaeger. Leiden: Brill, 1960</p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea">HNT</p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea">Handbuch zum Neuen Testament</p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea"><i>HTR</i></p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea"><i>Harvard Theological Review</i></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea">HUTh</p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea">Hermeneutische Untersuchungen zur Theologie</p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ign. <i>Eph. </i></p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ignatius of Antioch, <i>To the Ephesians</i></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ign. <i>Magn.</i></p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ignatius of Antioch, <i>To the Magnesians</i></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ign. <i>Pol.</i></p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ignatius of Antioch, <i>To Polycarp</i></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ign. <i>Rom.</i></p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea">Ignatius of Antioch, <i>To the Romans</i></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:4px;"><p class="txt_courant_ssalinea"><i>IJST</i></p></td>
<td style="padding:4px;"><p class="txt_courant_ssalinea"><i>International Journal of Systematic Theology</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">JCTCRS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Jewish and Christian Texts in Contexts and Related Studies Series</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JBL</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal of Biblical Literature</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">JSJSup</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Journal for the Study of Judaism Supplement Series</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JSNT</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal for the Study of the New Testament</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">JSNTSup</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Journal for the Study of the New Testament Supplement Series</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">JSOTSup</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Journal for the Study of the Old Testament Supplement Series</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">KEKNT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Kritisch-exegetischer Kommentar über das Neue Testament (Meyer-Kommentar)</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">LCC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Library of Christian Classics</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">LCL</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Loeb Classical Library</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">LNTS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Library of New Testament Studies</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Neot</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Neotestamentica</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NETS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>A New English Translation of the Septuagint</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NICNT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">New International Commentary on the New Testament</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NIGTC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">New International Greek Testament Commentary</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NIV</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">New International Version</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><span epub:type="pagebreak" id="page_XVIII" role="doc-pagebreak" title="XVIII">NovTSup</span></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Supplements to Novum Testamentum</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>NPNF</i><sup>1</sup></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Nicene and Post-Nicene Fathers</i>, series 1</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>NPNF</i><sup>2</sup></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Nicene and Post-Nicene Fathers</i>, series 2</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NSD</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">New Studies in Dogmatics</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NTL</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">New Testament Library</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>NTS</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>New Testament Studies</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">OECS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Oxford Early Christian Studies</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">OECT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Oxford Early Christian Texts</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">OSHT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Oxford Studies in Historical Theology</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Perseus</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Perseus Digital Library (<a class="url" href="http://www.perseus.tufts.edu/" target="_blank">www.perseus.tufts.edu/</a>)</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">PG</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Patrologia Cursus Completus: Series Graeca. </i>Edited by J. P. Migne. (Paris: 1857–1866)</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">PHSC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Perspectives on Hebrew Scriptures and its Contexts</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">PTS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Patristische Texte und Studien</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">RNT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Regensburger Neues Testament</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>RTR</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Reformed Theological Review</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">SC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Sources Chrétiennes</i> (Paris: Éditions du Cerf, 1942–)</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">SCDS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Studies in Christian Doctrine and Scripture</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Scholia</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Cyril of Alexandria, <i>Scholia de incarnatione unigeniti</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>SJT</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Scottish Journal of Theology</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">SNTSMS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Society for New Testament Studies Monograph Series</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>ST</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Thomas Aquinas, <i>Summa Theologiae</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">STDJ</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Studies on the Texts of the Desert of Judah</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Testimonies</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Leontius of Jerusalem, <i>Testimonies of the Saints</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Thesaurus</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Cyril of Alexandria, <i>Thesaurus de sancta consubstantiali trinitate</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">TTH</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Translated Texts for Historians</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">WBC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Word Biblical Commentary</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">WMANT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Wissenschaftliche Monographien zum Alten und Neuen Testament</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>WTJ</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Westminster Theological Journal</i></p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">WUNT</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ZAW</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Zeitschrift für die alttestamentliche Wissenschaft</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ZNW</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre5.vue?30e1a5c4